import React, { SVGProps } from 'react';

const SpyHiddenIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			width="100%"
			height="100%"
			viewBox="0 0 17 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g>
				<path
					d="M12.2999 1.59998H4.29993L3.49993 6.39998H13.0999L12.2999 1.59998ZM0.299927 7.99998C0.299927 7.99998 1.89993 8.79998 8.29993 8.79998C14.6999 8.79998 16.2999 7.99998 16.2999 7.99998L13.0999 6.39998H3.49993L0.299927 7.99998ZM6.69993 11.2H9.89993V12H6.69993V11.2Z"
					fill="white"
				/>
				<path
					d="M5.09995 14.4C6.42543 14.4 7.49995 13.3255 7.49995 12C7.49995 10.6745 6.42543 9.59998 5.09995 9.59998C3.77447 9.59998 2.69995 10.6745 2.69995 12C2.69995 13.3255 3.77447 14.4 5.09995 14.4Z"
					fill="white"
				/>
				<path
					d="M11.5 14.4C12.8255 14.4 13.9 13.3255 13.9 12C13.9 10.6745 12.8255 9.59998 11.5 9.59998C10.1745 9.59998 9.09998 10.6745 9.09998 12C9.09998 13.3255 10.1745 14.4 11.5 14.4Z"
					fill="white"
				/>
			</g>
		</svg>
	);
};

export default SpyHiddenIcon;
